import React from "react";

import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "@mui/material";

export const ErrorHandlingDesign = ({ errorMessage }) => {
  return (
    <>
      <section className="section-padding min-h-vh-50">
        <Container className="h-100">
          <div className="align-items-center h-100">
            <div className="no-product-found error-handler-wrap">
              <FontAwesomeIcon icon={faExclamationCircle} />
              <h5>{errorMessage}</h5>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};
